import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Grid,
    InputAdornment,
    IconButton,
    Divider,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Modal,
    CircularProgress,
    Dialog,
    DialogContent,
    MobileStepper,
    StepContent,
    Paper,
    SnackbarContent
} from "@mui/material";

import * as ApiService from "../../services/ApiService";
import { Label } from "@mui/icons-material";
import { IonItem, IonLabel, IonLoading, IonPage } from "@ionic/react";
import { ProviderContext } from "../../ApplicationState";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Html5Qrcode, Html5QrcodeScanner } from "html5-qrcode";
import { Turnstile } from '@marsidev/react-turnstile'; // [1] Import
import Button from '@mui/material/Button';
import * as signalR from "@microsoft/signalr";
import RegistrationLoader from "./RegistrationLoader";
import { Stepper, Step, StepLabel } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

// Cloufare_SITE_KEY : 0x4AAAAAACg9S-DsX43pG--Y
// Secret_key: 0x4AAAAAACg9Sy1ax0kXJdvkUIBVQF8LH68
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


type RegistrationStep =
    | "idle"
    | "registering"
    | "activating"
    | "finalizing"
    | "success"
    | "error";

interface FormData {
    hardware_name: string;
    hardware_uuid: string;
    external_id: string;
    //name: string;
    address: string;
    email: string;
    city: string;
    state: string;
    zipCode: string;
    phone_number: string;
    physician: string;
    provider_code: string;
    first_name: string;
    last_name: string;
}


//uuWSXdX8.2G6KKGfVshA6qMQgKIgJImNUz5zWWRjl
export const TenoviUsers: React.FC = () => {

    const initialFormState: FormData = {
        hardware_name: "",
        hardware_uuid: "",
        external_id: "",
        address: "",
        email: "",
        city: "",
        state: "",
        zipCode: "",
        phone_number: "",
        physician: "",
        provider_code: "",
        first_name: "",
        last_name: ""
    };
    const turnstileRef = React.useRef<any>(null);

    const [formData, setFormData] = useState<FormData>(initialFormState);

    const [open, setOpen] = useState(false);
    const [hardwareUuid, setHardwareUuid] = useState("");
    const [token, setToken] = useState(null); // [2] Token state
    const [method, setMethod] = useState('captcha'); // 'captcha' or 'sms'
    const [smsCode, setSmsCode] = useState('');
    const [smscodealert, setSmscodealert] = useState(false);
    const [helpOpen, setHelpOpen] = useState(true);

    const [step, setStep] = useState<RegistrationStep>("idle");
    const [loadingMessage, setLoadingMessage] = useState("");
    const [openLoader, setOpenLoader] = useState(false);
    const [showErroIcon, setShowErroIcon] = useState(false);
    const [showSucessIcon, setShowSucessIcon] = useState(false);
    const [touched, setTouched] = useState<{ [key: string]: boolean }>({}); //Track “touched” state
    const steps = [
        "Get Started",
        "Set Up Device",
        "Enter Details",
        "Verify & Submit"
    ];

    const [activeStep, setActiveStep] = useState(0);

    // -----------------------
    // Handlers
    // -----------------------
    // const handleNext = () => setActiveStep((prev) => prev + 1);
    // const handleBack = () => setActiveStep((prev) => prev - 1);

    // -----------------------
    // Navigation
    // -----------------------
    const handleNext = () => {
        if (!isStepValid()) return;

        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const stepMessages = {
        registering: "Registering account...",
        activating: "Activating devices...",
        finalizing: "Finalizing setup...",
        success: "✅ Setup completed successfully!",
        error: "Something went wrong..."
    };

    const setFieldValue = (name: string, value: string) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // -----------------------
    // QR Scanner
    // -----------------------
    const startScanner = () => {
        setOpen(true);
        console.log("startScanner startScanner")
        Html5Qrcode.getCameras().then(devices => {
            /**
             * devices would be an array of objects of type:
             * { id: "id", label: "label" }
             */
            if (devices && devices.length) {
                var cameraId = devices[0].id;
                // .. use this to start scanning.

                const html5QrCode = new Html5Qrcode("reader");
                const qrCodeSuccessCallback = (decodedText, decodedResult) => {

                    /* handle success */
                    setFieldValue("hardware_uuid", decodedText); // ✅ auto-fill form
                    html5QrCode.stop().then((ignore) => {
                        // QR Code scanning is stopped.
                    }).catch((err) => {
                        // Stop failed, handle it.
                    });
                    setOpen(false);

                    //alert(`qrCodeSuccessCallback : ${decodedText}  ${decodedResult}`)
                };

                const qrCodeErrorCallback = (errorMessage, error) => {
                    /* handle success */
                    ///alert(`qrCodeErrorCallback:  ${errorMessage}  ${error}`)
                };

                const config = { fps: 10, qrbox: { width: 100, height: 100 } };

                // If you want to prefer front camera
                //html5QrCode.start({ facingMode: "user" }, config, qrCodeSuccessCallback, qrCodeErrorCallback);

                // If you want to prefer back camera
                html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback, qrCodeErrorCallback);

                // Select front camera or fail with `OverconstrainedError`.
                //html5QrCode.start({ facingMode: { exact: "user" } }, config, qrCodeSuccessCallback, qrCodeErrorCallback);

                // Select back camera or fail with `OverconstrainedError`.
                // html5QrCode.start({ facingMode: { exact: "environment" } }, config, qrCodeSuccessCallback, qrCodeErrorCallback);



            }
        }).catch(err => {
            console.log("error camera setup qr ", err)
            // handle err
        });

        // setTimeout(() => {
        //     const scanner = new Html5Qrcode("reader");

        //     scanner.start(
        //         { facingMode: "environment" }, // back camera
        //         {
        //             fps: 10,
        //             qrbox: 250
        //         },
        //         (decodedText) => {
        //             setFieldValue("hardware_uuid", decodedText); // ✅ auto-fill form
        //             scanner.stop();
        //             setOpen(false);
        //         },
        //         (error) => {
        //             // ignore scan errors
        //         }
        //     );
        // }, 300);
    };



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setTouched(prev => ({
            ...prev,
            [name]: true
        }));
    };


    // -----------------------
    // Submit
    // -----------------------
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        //setLoading(true)
        setOpenLoader(true);
        setStep("registering");
        setLoadingMessage(stepMessages.registering);

        //----- uncomment for step verification----
        // 👇 If no token, trigger captcha FIRST

        if (!token) {
            // turnstileRef.current?.execute();
            setOpenLoader(false);
            alert("Please complete the security check.");
            //setLoadingMessage(`Please complete the security check.`);
            return;
        }
        // ----------------

        // const payload = {
        //     ...formData,
        //     verificationType: method,
        //     // Send whichever token is relevant
        //     verificationValue: method === 'captcha' ? token : smsCode
        // };

        // if (!payload.verificationValue) {
        //     return alert(`Please complete the ${method === 'captcha' ? 'Captcha' : 'SMS verification'}`);
        // }

        const fullAddress = `${formData.address} ${formData.city} ${formData.state} ${formData.zipCode}`
        const datatosend = {
            firstName: formData.first_name,
            lastName: formData.last_name,
            email: formData.email,
            providerCode: formData.provider_code,
            //providerName: (usergroup != null) ? usergroup.Description : string.Empty,
            deviceId: formData.hardware_uuid,
            deviceType: "",
            captchaToken: token,
            phone: formData.phone_number,
            address: fullAddress
        }

        console.log("data to send---> ", datatosend)

        // const datatosend = {
        //     device: {
        //         name: formData.hardware_name,
        //         hardware_uuid: formData.hardware_uuid
        //     },
        //     patient: {
        //         external_id: formData.external_id,
        //         phone_number: formData.phone_number
        //     }
        // }

        try {
            const response = await ApiService.createTenoviUsers(datatosend);

            if (response?.data?.success === false) {
                //alert(response.data.message);

                setShowErroIcon(true)
                setLoadingMessage(`${response.data.message}`);
                //setOpenLoader(false);
                // setTimeout(() => {
                //     setOpenLoader(false);
                // }, 10000)
                turnstileRef.current?.reset();
                setToken(null);
                return;
            }

            setShowSucessIcon(true)
            const sucessmessage = response.data.message || 'Registration successfully completed.'
            setLoadingMessage(sucessmessage);

            setActiveStep(4); // ✅ move to complete

            turnstileRef.current?.reset();
            setToken(null);

            //setOpenLoader(false);
            // setTimeout(() => {

            // }, 10000)
            // alert("User and Device activated successfully");

        } catch (ex: any) {
            turnstileRef.current?.reset();
            setToken(null);
            setShowErroIcon(true)
            // 1. Check if the backend sent a custom error message
            const backendMessage = ex.response?.data?.message || ex.response?.data?.error;
            // 2. Fallback to a generic message if the backend didn't provide one
            const displayMessage = backendMessage || stepMessages.error;
            setLoadingMessage(displayMessage);

            setTimeout(() => {
                setOpenLoader(false);
                setShowErroIcon(false)
            }, 3000)
        } finally {
            turnstileRef.current?.reset();
            setToken(null);
        }

    };

    // -------------------
    // Step Content
    // -------------------
    const renderStep = () => {

        switch (activeStep) {

            case 0:
                return (
                    <Box>
                        <Typography variant="h6" fontWeight={700}>
                            Activate Your Gateway Device
                        </Typography>

                        <Typography mt={2} pt={2}>
                            Securely share your vital data with your care team.
                        </Typography>

                        <Typography mt={1} pt={1}>
                            ⏱️ 3–5 min • 🔒 Secure
                        </Typography>
                    </Box>
                );

            case 1:
                return (
                    <Box>
                        <Typography fontWeight={600}>
                            Before you begin
                        </Typography>

                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>Plug in your gateway device</li>
                            <li>Locate Device ID (found on the back of the device)</li>
                        </Box>

                        <Grid>
                            <Typography pt={4} fontSize={15} fontWeight={500}>Scan QR or Type Device ID</Typography>
                        </Grid>


                        <Grid item xs={12}>
                            <TextField
                                required
                                fullWidth
                                label="Device Gateway ID"
                                name="hardware_uuid"
                                value={formData.hardware_uuid || ""}
                                onChange={handleChange}
                                error={!formData.first_name}
                                helperText={!formData.hardware_uuid ? "Required" : ""}
                            // InputProps={{
                            //     endAdornment: (
                            //         <InputAdornment position="end">
                            //             <IconButton onClick={startScanner}>
                            //                 <CameraAltIcon />
                            //             </IconButton>
                            //         </InputAdornment>
                            //     )
                            // }}
                            />
                        </Grid>

                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<CameraAltIcon />}
                            onClick={startScanner}
                            sx={{ mt: 2 }}
                        >
                            Scan Device QR
                        </Button>
                        <Grid item xs={12} mt={5}>
                            <div id="reader" width="100px"></div>
                        </Grid>
                    </Box>
                );

            case 2:
                return (
                    <Box component="form" onSubmit={handleSubmit}>
                        <Grid container spacing={{ xs: 2, sm: 3 }}>

                            <Grid item xs={12}>
                                <TextField required fullWidth label="Enter Your Provider Code" name="provider_code" onChange={handleChange}
                                    value={formData.provider_code || ""}
                                    error={!formData.provider_code}
                                    helperText={!formData.provider_code ? "Required" : ""} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    label="First Name"
                                    name="first_name"
                                    onChange={handleChange}
                                    value={formData.first_name || ""}
                                    error={!formData.first_name}
                                    helperText={!formData.first_name ? "Required" : ""} />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField required fullWidth label="Last Name" name="last_name" onChange={handleChange}
                                    value={formData.last_name || ""}
                                    error={!formData.last_name}
                                    helperText={!formData.last_name ? "Required" : ""} />
                            </Grid>


                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    onChange={handleChange}
                                    value={formData.email || ""}
                                    error={showError}
                                    helperText={
                                        formData.email.length === 0
                                            ? "Required"
                                            : emailValid
                                                ? "Looks good"
                                                : "Enter a valid email"
                                    } />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Phone Number" name="phone_number" onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField fullWidth label="Address" name="address" multiline rows={2} onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="City" name="city" onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="State" name="state" onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Zip Code" name="zip_code" onChange={handleChange} />
                            </Grid>

                            {/* <Grid item xs={12} display="flex" justifyContent="center">
                            <Turnstile
                                siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                
                                onSuccess={(token) => setToken(token)}
                                onExpire={() => setToken(null)}
                                ref={turnstileRef}
                            />
                        </Grid> */}


                            {/* <Grid item xs={12} mt={2}>
                            <Button
                                type="submit"
                                fullWidth
                                size="large"
                                variant="contained"
                                disabled={!token}
                            >
                                Submit
                            </Button>
                        </Grid> */}
                        </Grid>
                    </Box>
                );

            case 3:
                return (
                    <Box textAlign="center">
                        {/* <Typography fontWeight={600}>
                            Verify & Submit
                        </Typography> */}

                        <Typography mt={1} fontSize={15}>
                            Verifying your request…
                        </Typography>

                        <Box mt={2} display="flex" justifyContent="center">
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Turnstile
                                    siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                    onSuccess={(token) => setToken(token)}
                                    onExpire={() => setToken(null)}
                                    ref={turnstileRef}
                                />
                            </Grid>
                        </Box>
                        <Typography variant="caption" color="text.secondary" mt={1}>
                            This helps prevent unauthorized access
                        </Typography>


                        <Box border="1px solid" borderColor="grey.500" p={2} textAlign="start" mt={5} >

                            <Typography fontWeight={700}>
                                What happens next?
                            </Typography>

                            <Typography>Follow the remaining instructions provided in your gateway box for next steps</Typography>

                        </Box>

                        {/* <Box border="1px solid" borderColor="grey.500" p={2} textAlign="start" mt={2}>
                            <Typography fontWeight={700}>
                                Need help?
                            </Typography>
                            <Typography >
                                If you have questions or need assistance with activation or use of your medical device:
                            </Typography>
                            <Typography >
                                📞  855 695 4525 (Select Option 2)
                            </Typography>

                            <Typography>
                                ✉️  ccsupport@medline.com
                            </Typography>
                        </Box> */}

                        {/* <Button sx={{ mt: 2 }} onClick={() => setActiveStep(0)}>
                            Start Over
                        </Button> */}

                        <Typography fontSize={14} pt={2}>
                            Your Activation request will be completed after submission
                        </Typography>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={!token}
                            //sx={{ mt: 2 }}
                            onClick={handleSubmit}
                        >
                            Submit Activation
                        </Button>
                    </Box>
                );

            default:
                return (
                    <Box textAlign="center">
                        <Typography variant="h6">
                            ✅ Activation Completed
                        </Typography>

                        <Typography pt={2}>
                            Any questions or need assistance with activation or use of your medical device:
                        </Typography>

                        <Typography mt={2}>
                            📞 855 695 4525
                        </Typography>

                        <Typography>
                            ✉️ ccsupport@medline.com
                        </Typography>

                        <Button sx={{ mt: 3 }} onClick={() => setActiveStep(0)}>
                            Start Over
                        </Button>
                    </Box>
                );
        }
    };

    const isStepValid = () => {
        switch (activeStep) {
            case 1:
                return !!formData.hardware_uuid;

            case 2:
                return (
                    !!formData.provider_code &&
                    !!formData.first_name &&
                    !!formData.last_name &&
                    isValidEmail(formData.email)
                );

            case 3:
                return !!token;

            default:
                return true;
        }
    };

    const isValidEmail = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const emailValid = isValidEmail(formData.email);
    const showError = formData.email.length >= 0 && !emailValid;
    const phoneRegex = /^(\+?1)?\d{10}$/;
    const isPhoneValid = phoneRegex.test(formData.phone_number)
    console.log('isPhoneValid-->', isPhoneValid)
    {/* Render the selected verification tool directly below the choice */ }
    {/* <Box mt={2} width="100%" display="flex" justifyContent="center">
                                        {method === 'captcha' ? (
                                            <Turnstile
                                                siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                                onSuccess={(token) => setToken(token)}
                                            />
                                        ) : (
                                            <Box display="flex" width="100%" maxWidth={500} >
                                                <TextField
                                                    fullWidth
                                                    disabled={token}
                                                    label="Enter Your Mobile Number"
                                                    value={smsCode}
                                                    onChange={(e) => setSmsCode(e.target.value)}
                                                />

                                                <Button
                                                    disabled={token}
                                                    autoCapitalize={'none'}
                                                    variant='contained'
                                                    onClick={() => {
                                                        setSmscodealert(true)
                                                    }}
                                                    sx={{
                                                        whiteSpace: 'nowrap',
                                                        height: 30,
                                                        width: 200,
                                                        alignSelf: 'center',
                                                    }}
                                                >
                                                    {!token ? 'Send Code' : '✅ Verified'}
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>  */}




    // -----------------------
    // Step Content
    // -----------------------
    const renderStepContent = (index: number) => {

        switch (index) {

            case 0:
                return (
                    <Box>
                        <Typography variant="h6" fontWeight={700}>
                            Activate Your Gateway Device
                        </Typography>

                        <Typography pt={2}>
                            Securely connect your device to share health data with your care team.
                        </Typography>

                        <Typography pt={2}>
                            ⏱️ 3–5 min • 🔒 Secure
                        </Typography>
                    </Box>
                );

            case 1:
                return (
                    <Box>
                        <Typography fontWeight={600}>
                            Before you begin
                        </Typography>

                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>Plug in your gateway device</li>
                            <li>Locate Device ID (found on the back of the device)</li>
                            <li>Scan QR or Type Device ID</li>
                        </Box>

                        {/* <Grid>
                            <Typography fontSize={15} fontWeight={500}>Scan QR or Type Device ID</Typography>
                        </Grid> */}


                        <Grid item xs={12} pt={2}>
                            <TextField
                                required
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                label="Device Gateway ID"
                                name="hardware_uuid"
                                value={formData.hardware_uuid || ""}
                                onChange={handleChange}
                                error={!formData.first_name}
                                helperText={!formData.hardware_uuid ? "Required" : ""}
                                // InputProps={{
                                //     endAdornment: (
                                //         <InputAdornment position="end">
                                //             <IconButton onClick={startScanner}>
                                //                 <CameraAltIcon />
                                //             </IconButton>
                                //         </InputAdornment>
                                //     )
                                // }}
                                sx={{
                                    "& .MuiInputBase-input": {
                                        paddingTop: '25px', // Increases space below the label
                                    }
                                }}
                            />
                        </Grid>

                        <Typography
                            textAlign="center"
                            fontWeight={600}
                            mt={2}
                        >
                            Or
                        </Typography>

                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<CameraAltIcon />}
                            onClick={startScanner}
                            sx={{ mt: 2 }}
                        >
                            Scan Device QR
                        </Button>
                        <Grid item xs={12} mt={5}>
                            <div id="reader" width="100px"></div>
                        </Grid>
                    </Box>
                );

            case 2:
                return (
                    <Box component="form" onSubmit={handleSubmit}>
                        <Grid container spacing={{ xs: 2, sm: 3 }}>

                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Enter Your Provider Code"
                                    name="provider_code"
                                    onChange={handleChange}
                                    value={formData.provider_code || ""}
                                    error={!formData.provider_code}
                                    helperText={!formData.provider_code ? "Required" : ""}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="First Name"
                                    name="first_name"
                                    onChange={handleChange}
                                    value={formData.first_name || ""}
                                    error={!formData.first_name}
                                    helperText={!formData.first_name ? "Required" : ""}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField required fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Last Name" name="last_name" onChange={handleChange}
                                    value={formData.last_name || ""}
                                    error={!formData.last_name}
                                    helperText={!formData.last_name ? "Required" : ""}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>


                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Email"
                                    name="email"
                                    onChange={handleChange}
                                    value={formData.email || ""}
                                    error={showError}
                                    helperText={
                                        formData.email.length === 0
                                            ? "Required"
                                            : emailValid
                                                ? "Looks good"
                                                : "Enter a valid email"
                                    }
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    placeholder='+1XXXXXXXXXX'
                                    label="Phone Number"
                                    name="phone_number"
                                    // error={!isPhoneValid}
                                    onChange={handleChange}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }}
                                    helperText={'format must be +1XXXXXXXXXX'}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Address" name="address" multiline rows={2} onChange={handleChange}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="City" name="city" onChange={handleChange}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="State" name="state" onChange={handleChange}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Zip Code" name="zip_code" onChange={handleChange}
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            paddingTop: '25px', // Increases space below the label
                                        }
                                    }} />
                            </Grid>

                            {/* <Grid item xs={12} display="flex" justifyContent="center">
                            <Turnstile
                                siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                
                                onSuccess={(token) => setToken(token)}
                                onExpire={() => setToken(null)}
                                ref={turnstileRef}
                            />
                        </Grid> */}


                            {/* <Grid item xs={12} mt={2}>
                            <Button
                                type="submit"
                                fullWidth
                                size="large"
                                variant="contained"
                                disabled={!token}
                            >
                                Submit
                            </Button>
                        </Grid> */}
                        </Grid>
                    </Box>
                );

            case 3:
                return (
                    <Box textAlign="center">
                        {/* <Typography fontWeight={600}>
                        Verify & Submit
                    </Typography> */}

                        <Typography mt={1} fontSize={15}>
                            Verifying your request…
                        </Typography>

                        <Box mt={2} display="flex" justifyContent="center">
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Turnstile
                                    siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                    onSuccess={(token) => setToken(token)}
                                    onExpire={() => setToken(null)}
                                    ref={turnstileRef}
                                />
                            </Grid>
                        </Box>
                        <Typography variant="caption" color="text.secondary" mt={1}>
                            This helps prevent unauthorized access
                        </Typography>


                        <Box bgcolor={'#F6F7F9'} border="1px solid" borderColor="grey.500" p={2} textAlign="start" mt={5} >

                            <Typography color={'black'} fontWeight={700}>
                                What happens next?
                            </Typography>

                            <Typography color={'black'} >• Follow the remaining instructions provided in your gateway box for next steps</Typography>

                        </Box>

                        {/* <Box border="1px solid" borderColor="grey.500" p={2} textAlign="start" mt={2}>
                        <Typography fontWeight={700}>
                            Need help?
                        </Typography>
                        <Typography >
                            If you have questions or need assistance with activation or use of your medical device:
                        </Typography>
                        <Typography >
                            📞  855 695 4525 (Select Option 2)
                        </Typography>

                        <Typography>
                            ✉️  ccsupport@medline.com
                        </Typography>
                    </Box> */}

                        {/* <Button sx={{ mt: 2 }} onClick={() => setActiveStep(0)}>
                        Start Over
                    </Button> */}

                        <Typography fontSize={14} pt={3}>
                            Your Activation request will be completed after submission
                        </Typography>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={!token}
                            //sx={{ mt: 2 }}
                            onClick={handleSubmit}
                        >
                            Submit Activation
                        </Button>
                    </Box>
                );
        }
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const action = (
        <Button color="secondary" size="small">
            Close
        </Button>
    );

    return (
        <IonPage>
            <Box
                minHeight="100vh"
                height="100dvh"
                width="100%"
                bgcolor="#f4f6f8"
                display="flex"
                justifyContent="center"
                alignItems="stretch"
                padding={{ xs: 1, sm: 3 }}
                overflow="hidden"
            //p={10}
            // sx={{ overflowY: "hidden", WebkitOverflowScrolling: 'touch' }}
            >
                <Card
                    sx={{
                        width: "100%",
                        maxWidth: 700,
                        borderRadius: 3,
                        height: "100dvh",     // 👈 FULL SCREEN
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <CardContent
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            p: 3
                        }}
                    // sx={{ padding: { xs: 2, sm: 4 } }}
                    >


                        {/* Stepper */}
                        <Box sx={{
                            flex: 1,
                            overflowY: "auto",
                            WebkitOverflowScrolling: "touch",
                            // pb: 2
                            // 👇 IMPORTANT
                            pb: helpOpen ? "260px" : "90px",
                            transition: "padding-bottom 0.25s ease"
                        }}>

                            <Stepper
                                activeStep={activeStep}
                                orientation="vertical"
                                sx={{
                                    // "& .MuiStepContent-root": {
                                    //     marginLeft: "10px",
                                    //     paddingLeft: "10px"
                                    // },
                                    // "& .MuiStepConnector-line": {
                                    //     minHeight: "8px"
                                    // },
                                    // "& .MuiStep-root": {
                                    //     paddingBottom: "4px"
                                    // },
                                    // "& .MuiStepLabel-label": {
                                    //     fontSize: "14px"
                                    // }
                                }}
                            >
                                {steps.map((label, index) => (
                                    <Step key={label} completed={activeStep > index}>
                                        <StepLabel>{label}</StepLabel>

                                        <StepContent>

                                            <Box sx={{ mt: 1, mb: 2 }}>
                                                {renderStepContent(index)}
                                            </Box>


                                            <Box sx={{ mb: 2, mt: 4 }}>
                                                {index !== steps.length - 1 && (
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleNext}
                                                        disabled={!isStepValid()}
                                                        sx={{ mr: 1 }}
                                                    >
                                                        {"Continue"}
                                                    </Button>
                                                )}

                                                <Button
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                >
                                                    Back
                                                </Button>
                                            </Box>

                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>


                            {activeStep === steps.length && (
                                <Paper square elevation={0} sx={{ p: 3 }}>
                                    <Typography fontSize={18} fontWeight={'bold'}>✅ Activation Completed</Typography>
                                    <Typography pt={2}>Your gateway should now display a solid red light.
                                    </Typography>
                                    <Typography pt={2}>You can close this browser and begin taking readings.</Typography>
                                    <Typography pt={2}>See the instructions in the box.</Typography>
                                    <Button variant="contained" onClick={handleReset} sx={{ mt: 4, mr: 1 }}>
                                        Start Over
                                    </Button>
                                </Paper>
                            )}
                        </Box>

                        <Box
                            sx={{
                                position: "sticky",
                                bottom: 12,
                                display: "flex",
                                justifyContent: "center",
                                zIndex: 20,
                                mt: 2
                            }}
                        >
                            <Button
                                variant="contained"
                                startIcon={<HelpOutlineIcon />}
                                onClick={() => setHelpOpen(true)}
                                sx={{
                                    borderRadius: 999,
                                    px: 3
                                }}
                            >
                                Need Help?
                            </Button>
                        </Box>

                        {helpOpen && (
                            <Box
                                sx={{
                                    position: "fixed",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    bgcolor: "#fff",
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
                                    p: 3,
                                    zIndex: 9999,
                                    animation: "slideUp 0.25s ease"
                                }}
                            >

                                {/* Header */}
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mb={2}
                                >
                                    <Typography fontWeight={700} fontSize={18}>
                                        Need help?
                                    </Typography>

                                    <IconButton onClick={() => setHelpOpen(false)}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>

                                <Typography fontSize={14}>
                                    If you have questions or need assistance with activation or use of your medical device:
                                </Typography>

                                <Typography fontSize={14} pt={2} fontWeight="bold">
                                    📞 855 695 4525 (Select Option 2)
                                </Typography>

                                <Typography fontSize={14} pt={1} fontWeight="bold">
                                    ✉️ ccsupport@medline.com
                                </Typography>
                            </Box>
                        )}

                        {/* Step indicator */}
                        {/* <Typography variant="caption">
                            {activeStep + 1 !== 5 ? `Step ${activeStep + 1} of ${steps.length}` : ''}
                        </Typography>

                        <Typography variant="subtitle1" fontWeight={600} mb={2}>
                            {steps[activeStep]}
                        </Typography> */}

                        {/* {renderStep()} */}


                        {/* Mobile Stepper */}
                        {/* {activeStep < 4 && (
                            <MobileStepper
                                variant="dots"
                                steps={steps.length}
                                position="static"
                                activeStep={activeStep}
                                style={{ marginTop: 20 }}
                                nextButton={
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={handleNext}
                                        disabled={activeStep === steps.length - 1 || !isStepValid()}
                                    >
                                        Next
                                    </Button>
                                }
                                backButton={
                                    <Button
                                        size="small"
                                        onClick={handleBack}
                                        disabled={activeStep === 0}
                                    >
                                        Back
                                    </Button>
                                }
                            />
                        )} */}



                        {/* <Typography variant="h5" fontWeight={600} gutterBottom>
                            Patient Information
                        </Typography>

                        <Typography variant="body2" color="text.secondary" mb={3}>
                            Please fill in the details below
                        </Typography> */}

                        {/* <Box component="form" onSubmit={handleSubmit}>
                            <Grid container spacing={{ xs: 2, sm: 3 }}>
                               
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="Device Gateway ID"
                                        name="hardware_uuid"
                                        value={formData.hardware_uuid || ""}
                                        onChange={handleChange}
                                        helperText="Scan QR from device label"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={startScanner}>
                                                        <CameraAltIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <div id="reader" width="100px"></div>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField required fullWidth label="Enter Your Provider Code" name="provider_code" onChange={handleChange} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField required fullWidth label="First Name" name="first_name" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField required fullWidth label="Last Name" name="last_name" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField fullWidth label="Address" name="address" multiline rows={2} onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField required fullWidth label="Email" name="email" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField fullWidth label="Phone Number" name="phone_number" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <TextField fullWidth label="City" name="city" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <TextField fullWidth label="State" name="state" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <TextField fullWidth label="Zip Code" name="zip_code" onChange={handleChange} />
                                </Grid>

                                <Grid item xs={12} display="flex" justifyContent="center">
                                    <Turnstile
                                        siteKey="0x4AAAAAACg9S-DsX43pG--Y"
                                        
                                        onSuccess={(token) => setToken(token)}
                                        onExpire={() => setToken(null)}
                                        ref={turnstileRef}
                                    />
                                </Grid>


                                <Grid item xs={12} mt={2}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        size="large"
                                        variant="contained"
                                        disabled={!token}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box> */}

                    </CardContent>

                </Card >

            </Box>


            <RegistrationLoader
                open={openLoader}
                message={loadingMessage}
                error={showErroIcon}
                sucess={showSucessIcon}
                setOpenLoader={setOpenLoader}
                setShowErroIcon={setShowErroIcon}
            />

            {/* {smscodealert && (
                <Modal
                    open={smscodealert}
                    onClose={() => {
                        setSmscodealert(false)
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box display="flex" width="100%" maxWidth={500}>
                            <TextField
                                fullWidth
                                label="Enter SMS Code"
                                value={smsCode}
                                onChange={(e) => setSmsCode(e.target.value)}
                            />
                            <Button
                                autoCapitalize={'none'}
                                variant='text'
                                onClick={() => {
                                    setLoading(true)

                                    setTimeout(() => {
                                        setLoading(false)
                                        setSmscodealert(false)
                                        setToken('assa')
                                    }, 10000)
                                }}

                                sx={{ whiteSpace: 'nowrap', height: 30, width: 200, alignSelf: 'center' }}
                            >
                                {loading ? 'Verifying...' : 'Verify'}
                            </Button>


                        </Box>
                    </Box>
                </Modal>
            )} */}
        </IonPage >

    );
};